
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/year-in-photos",
      function () {
        return require("private-next-pages/year-in-photos.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/year-in-photos"])
      });
    }
  